module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/insights-priya-rajan.json
// module id = 1403
// module chunks = 212375672671688